// Public
export const LOGIN = '/login';
export const RESET_PASSWORD = '/reset-password';
// Private
export const PRIVATE = '/private';
export const ORGANIGRAMA = PRIVATE + '/organigrama';
export const LOGOUT = PRIVATE + '/logout';
// Private User
export const PRIVATE_USER = PRIVATE + '/user';
// Private Admin
export const PRIVATE_ADMIN = PRIVATE + '/admin';
export const VACACIONES = PRIVATE + '/vacaciones';
export const EXTRAS = PRIVATE + '/extras';
export const EXTRAS_REPARACIONES = PRIVATE + '/extras-reparaciones';
export const EXTRAS_ORGANIGRAMA = ORGANIGRAMA + '/extras';
export const PORTAL = PRIVATE_USER + '/portal';
export const PRIVATE_ADMIN_NEWS = PRIVATE_ADMIN + '/noticias';
export const PRIVATE_ADMIN_REPORTS = PRIVATE_ADMIN + '/reports';
export const CORPORATE_DOCUMENTS = PRIVATE + '/documentos';
export const PRIVATE_ADMIN_DOCUMENTS = PRIVATE_ADMIN + '/documentos';
